module.exports = __webpack_public_path__ + "static/media/service-block-6.9e9b5174.jpg";